import React from "react";

/**
 * The design's dark-pill switch ("Compare with", "Week | Month"…).
 *
 * @param {Object} props
 * @param {Array<{key: string, label: string, active: boolean}>} props.options
 * @param {(key: string) => void} props.onPick
 * @param {string} props.label - The group's accessible name.
 */
const Segmented = ({ options, onPick, label }) => (
  <div role="group" aria-label={label} className="flex gap-[2px] p-[2px] bg-white border border-[#E8E0D9] rounded-[8px]">
    {options.map((o) => (
      <button
        key={o.key}
        type="button"
        aria-pressed={o.active}
        onClick={() => onPick(o.key)}
        className={`focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#F26A1F] px-[12px] py-[5px] rounded-[6px] text-[12px] font-bold whitespace-nowrap cursor-pointer transition-colors duration-200 ${
          o.active ? "bg-[#1f1f1f] text-white" : "text-[#555] hover:bg-[#F6F2EF]"
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export default Segmented;
